import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { BibleBookSection } from '../components/bible-book/bible-book.component';

@Injectable()
export class BibleBookService {

  constructor(private apiSvc: ApiService) { }

  public loadSections(): Promise<BibleBookSection[]> {

    const p = new Promise<BibleBookSection[]>((resolve, reject) => {

      this.apiSvc.get("api/biblebooksections", null).subscribe(
        (data: BibleBookSection[]) => {
          console.log("BibleBookService.loadSections", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }
}
